import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ut_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // CSRF marker for cookie-authenticated calls (backend requires it on mutations)
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

// Bump IMG_V whenever product photos are refreshed — the query string busts
// Cloudflare's 7-day edge cache so shoppers always see the latest images.
const IMG_V = "20261018a";

export const imgUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  return `${process.env.REACT_APP_BACKEND_URL}${p}?v=${IMG_V}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

